import {
  PROVIDER_CREATE_REQUEST_FAIL,
  PROVIDER_CREATE_REQUEST_SUCCESS,
  SELECT_PROVIDER
} from '../action.types'
import initialState from '../initial.state'

export default (state = initialState.provider, action) => {
  switch (action.type) {
    case SELECT_PROVIDER:
      return { ...action.provider };
    case PROVIDER_CREATE_REQUEST_SUCCESS:
      return state
    case PROVIDER_CREATE_REQUEST_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/provider/provider.reducer.js